import { render, staticRenderFns } from "./FormW4.vue?vue&type=template&id=93e1517a&"
import script from "./FormW4.vue?vue&type=script&lang=ts&"
export * from "./FormW4.vue?vue&type=script&lang=ts&"
import style0 from "./FormW4.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports